/** Read-model tags aligned with `deleteRoute` mutation invalidation (BUG-3 / partial create rollback). */
export const ROUTE_DELETE_READ_MODEL_TAGS = [
  'Route',
  'Cargo',
  'Application',
  'CargoHistory',
  'Workspace'
] as const;

export type RouteDeleteReadModelInvalidateTag =
  | (typeof ROUTE_DELETE_READ_MODEL_TAGS)[number]
  | { type: 'Route'; id: number };

export function routeDeleteReadModelInvalidatesTags(
  routeId?: number
): RouteDeleteReadModelInvalidateTag[] {
  const tags: RouteDeleteReadModelInvalidateTag[] = [...ROUTE_DELETE_READ_MODEL_TAGS];
  if (routeId != null && Number.isFinite(Number(routeId))) {
    return [{ type: 'Route', id: Number(routeId) }, ...tags];
  }
  return tags;
}
